import React, { Component } from "react";
import KpsListItem from "../../core-elements/KpsListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import { withRouter } from "react-router-dom";
import DoneIcon from "@material-ui/icons/Done";
import Typography from "@material-ui/core/Typography";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { withTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { Trans, withTranslation } from "react-i18next";
import axios from "../../AxiosClient";
import moment from "moment";
import { Badge, Tooltip } from "@material-ui/core";
import DisplayUser from "../user/DisplayUser";
import Link from "@material-ui/core/Link";

export class ItemRequiredReading extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    setExtendedString: PropTypes.func.isRequired,
  };

  state = {
    dialogOpen: false,
    instance: new Date().getTime().toString(),
    documents: this.props.data.requiredReadingDocuments || [],
    extendedString: "",
    secondaryString: "",
  };
  extendedInfo(settings) {
    if (!settings) {
      settings = [];
      for (let i = 0; i < this.props.requiredReadingOptions.length; i++) {
        settings.push({
          label: this.props.requiredReadingOptions[i],
          order: i,
        });
      }
    } else {
      settings = JSON.parse(settings);
    }
    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          return (
            <TableRow>
              <TableCell>{this.props.t(setting.label)}</TableCell>
              {this.getSettingInfo(setting)}
            </TableRow>
          );
        })}
      </>
    );
    this.setState({ extendedString: extendedString });
  }
  componentDidMount() {
    this.extendedInfo(null);
    this.defaultFullscreenInfo(this.props.fullscreenSettings);
    // this.secondaryInfo(this.props.listSettings);
    if (this.props.fullscreen) {
      this.secondaryInfo(this.props.fullscreenSettings);
    } else {
      this.secondaryInfo(this.props.listSettings);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.fullscreen != prevProps.fullscreen) {
      if (this.props.fullscreen) {
        this.secondaryInfo(this.props.fullscreenSettings);
      } else {
        this.secondaryInfo(this.props.listSettings);
      }
    }
    if (
      prevProps.listSettings !== this.props.listSettings &&
      !this.props.fullscreen
    ) {
      this.secondaryInfo(this.props.listSettings);
    }
    if (
      this.props.fullscreenSettings != prevProps.fullscreenSettings &&
      this.props.fullscreen
    ) {
      this.secondaryInfo(this.props.fullscreenSettings);
    }
  }
  defaultFullscreenInfo(settings) {
    if (!settings || settings.length === 0) {
      settings = [];
      if (this.props.requiredReadingOptions) {
        for (let i = 0; i < this.props.requiredReadingOptions.length; i++) {
          settings.push({
            label: this.props.requiredReadingOptions[i],
            order: i,
          });
        }
      }
    } else {
      try {
        let jsonsettings = JSON.parse(settings);
        settings = jsonsettings;
      } catch (x) {
        settings = [{ label: settings, order: 0 }];
      }
    }
    var fullScreenString = (
      <>
        {settings.map((setting, idx) => {
          return <>{this.getSettingInfo(setting)}</>;
        })}
      </>
    );
    this.setState({ defaultFullscreen: fullScreenString });
  }
  returnSettingItem = (settings) => {
    const { classes } = this.props;
    let fontWeight = { fontWeight: this.props.fullscreen ? "bold" : "normal" };

    return (
      // <span className={classes.iconSpan}>
      <span>
        {settings === "required_reading_date_created" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("required_reading_date_created")}
            </div>
            <div>: {this.props.data.created}&nbsp;</div>
          </div>
        )}
        {settings === "required_reading_expiry_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("required_reading_expiry_date")}
            </div>
            <div>: {this.props.data.expiry}&nbsp;</div>
          </div>
        )}
        {settings === "required_reading_description" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("required_reading_description")}
            </div>
            <div>: {this.props.data.description}&nbsp;</div>
          </div>
        )}
        {settings === "required_reading_number_of_documents" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("required_reading_number_of_documents")}
            </div>
            <div>: {this.props.data.requiredReadingDocuments.length}&nbsp;</div>
          </div>
        )}
        {settings === "required_reading_owner" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              <div style={fontWeight}>
                {this.props.t("required_reading_owner")}:
              </div>
              <div>
                <DisplayUser
                  noAvatar
                  userId={
                    this.props.data.owner ? this.props.data.owner.userId : ""
                  }
                  user={this.props.data.owner}
                />
              </div>
            </div>
          </div>
        )}
      </span>
    );
  };
  getSettingInfo = (setting) => {
    return (
      <>
        {setting.label === "required_reading_date_created" && (
          <TableCell>{this.props.data.created}</TableCell>
        )}
        {setting.label === "required_reading_expiry_date" && (
          <TableCell>{this.props.data.expiry}</TableCell>
        )}
        {setting.label === "required_reading_number_of_documents" && (
          <TableCell>
            {this.props.data.requiredReadingDocuments.length}
          </TableCell>
        )}
        {setting.label === "required_reading_description" && (
          <TableCell>{this.props.data.description}</TableCell>
        )}
        {setting.label === "required_reading_owner" && (
          <TableCell>
            <DisplayUser
              userId={this.props.data.owner ? this.props.data.owner.userId : ""}
              user={this.props.data.owner}
            />
          </TableCell>
        )}
      </>
    );
  };
  render() {
    let readDocuments = 0;
    let totalDocuments = this.props.data.requiredReadingDocuments.length;
    this.props.data.requiredReadingDocuments.forEach((element) => {
      if (element.read) {
        readDocuments++;
      }
    });
    let isCompleted =
      this.props.data.percentCompleted === 100 ||
      readDocuments === totalDocuments;
    const { classes } = this.props;
    return (
      <KpsListItem
        id="required-reading-list-item"
        extendedString={this.state.extendedString}
        onItemClick={this.onItemClick}
        preText={this.props.preText}
        provided={this.props.provided}
        menuDialog={this.props.menuDialog}
        fullscreen={this.props.fullscreen}
        fullscreenSettings={
          this.props.fullscreenSettings &&
          this.props.fullscreenSettings !== null
            ? JSON.parse(this.props.fullscreenSettings).map((setting, idx) => {
                return <>{this.getSettingInfo(setting)}</>;
              })
            : this.state.defaultFullscreen
        }
      >
        {this.props.preText}
        <ListItemIcon>
          <Tooltip
            title={
              <Typography>
                {isCompleted
                  ? this.props.t("required_reading_task_complete")
                  : this.props.t("required_reading_num_documents_read", {
                      readDocuments,
                      totalDocuments,
                    })}
              </Typography>
            }
          >
            <div style={{ width: 35, paddingTop: 10 }}>
              {isCompleted ? (
                <DoneIcon
                  style={{ color: this.props.theme.palette.primary.main }}
                />
              ) : (
                <CircularProgressbar
                  value={readDocuments / totalDocuments}
                  maxValue={1}
                  text={`${readDocuments} / ${totalDocuments}`}
                  styles={buildStyles({
                    textSize: "35px",
                    pathColor: this.props.theme.palette.primary.main,
                    textColor: this.props.theme.palette.primary.main,
                  })}
                />
              )}
            </div>
          </Tooltip>
        </ListItemIcon>
        {this.props.fullscreen ? (
          <Link
            id="required-reading-link"
            component="button"
            color="inherit"
            underline="none"
            // classes={{ button: classes.buttontitle }}
            onClick={this.onItemClick}
          >
            {this.props.data.title}
          </Link>
        ) : (
          <ListItemText
            primary={this.props.data.title}
            // secondary={this.props.data.description}
            secondary={this.state.secondaryString}
          />
        )}
        <Dialog
          open={this.state.dialogOpen}
          onClose={this.handleClose}
          fullWidth
        >
          <DialogTitle>{this.props.data.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{this.props.data.description}</DialogContentText>
            <List>
              {this.props.data.requiredReadingDocuments.map((ele) => {
                return (
                  <>
                    <ListItem
                      button
                      onClick={() => this.openDocument(ele.documentID)}
                    >
                      <ListItemText
                        primary={ele.userTitle}
                        style={{ overflowWrap: "anywhere" }}
                        secondary={
                          ele.read ? (
                            <span style={{ display: "flex" }}>
                              <DoneIcon />
                              <Typography>
                                {this.props.t("required_reading_read_on", {
                                  date: moment(ele.dateRead).format(
                                    "DD/MM/YYYY HH:mm"
                                  ),
                                  interpolation: { escapeValue: false },
                                })}
                              </Typography>
                            </span>
                          ) : (
                            <Trans i18nKey="required_reading_unread" />
                          )
                        }
                      />
                    </ListItem>
                    <Divider />
                  </>
                );
              })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              <Trans i18nKey="global_close" />
            </Button>
          </DialogActions>
        </Dialog>
      </KpsListItem>
    );
  }
  secondaryInfo(settings) {
    if (this.props.fullscreen) {
      if (!this.props.fullscreenSettings) {
        settings = [];
        for (let i = 0; i < this.props.requiredReadingOptions.length; i++) {
          settings.push({
            label: this.props.requiredReadingOptions[i],
            order: i,
          });
        }
      } else {
        settings = JSON.parse(settings);
      }
    }
    const { classes } = this.props;
    let info = (
      <div style={{ display: "flex" }}>
        {this.props.fullscreen
          ? settings.map((setting) => {
              return this.returnSettingItem(setting.label);
            })
          : this.returnSettingItem(settings)}
      </div>
    );
    this.setState({ secondaryString: info });
  }
  handleClose = (e) => {
    e.stopPropagation();
    this.setState({ dialogOpen: false });
  };

  openDocument = (id) => {
    this.props.history.push(`/full/document/${id}`);
  };

  onItemClick = () => {
    if (this.props.data.requiredReadingDocuments.length === 1) {
      this.props.close && this.props.close();
      this.props.history.push(
        `/full/document/${
          this.props.data.requiredReadingDocuments[0].documentID
        }`
      );
    } else {
      axios.get(`/requiredreading/${this.props.data.id}`,{withCredentials: true}).then((res) => {
        this.setState({ documents: res.data, dialogOpen: true });
      });
    }
  };
}

const mapStateToProps = (state) => ({
  requiredReadingOptions: state.selectionOption.requiredReadingSettingsOptions,
});

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(withTheme(withTranslation()(ItemRequiredReading)))
);
